import {MODAL_WINDOW} from "./types";

export function showModalWindowAction(modalWindowPayload) {

  return {
    type: MODAL_WINDOW.SHOW,
    payload: modalWindowPayload
  };
}

export function hideModalWindowAction() {
  return {
    type: MODAL_WINDOW.HIDE,
  };
}